import React from 'react';
import MyPhoto2 from '../../img/about.jpeg';
import './About.css';
import { themeContext } from '../../Contest';
import { useContext } from 'react';
import {motion} from 'framer-motion';


const About = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode
  const birthDate = '27,May,2002 (Monday)';
  const Age = 20;
  const Address = 'Yangon';
  const Email = 'kyawlwinsoe812@gmail.com'
  const PhoneNumber = '09428256980';
  const Github = 'KyawLwin27';
  return (
    <div className='about' id='About'>
      <div className="a-left">
        <h1>About Me</h1>
        <h2 style={{ color: darkMode? 'white': ''}}>I'm Kyaw Lwin Soe - <span>Junior Web Developer</span></h2>
        <p style={{ color: darkMode? 'white': ''}}>
        I'm junior web developer and learning Software Engineering Subject.
        <span>My native town is Mawlamyine and we moved from Mawlamyine since 2012 May. I've four family members. I'm the youngest one. I've one brother and one sister. I've Mother but my father passed away in 2010 May 23.
        Now, I'm second year student of International Relations at Dagon University since 2020.I'm interested in Programming. I love Coding.
        </span>
        </p>
        <div className="list">
        <div className="leftSide">
          <ul>
            <li>Birthday:<span>{birthDate}</span> </li>
            <li>Age: <span>{Age }years</span>  </li>
            <li>Address: <span>{Address}</span> </li>
          </ul>
        </div>

        <div className="rightSide">
          <ul>
            <li>Email: <span>{Email}</span> </li>
            <li>Phone Number: <span>{PhoneNumber}</span></li>
            <li>Github: <span>{Github}</span></li>
          </ul>
        </div>
        </div>

      </div>
      <div className="a-right">
        
        <motion.img 
        initial={{left: '50rem'}}
        whileInView={{left: '35rem'}}
        transition={{delay: 0.5, type:'spring'}}
        
        src={MyPhoto2} alt="" />
      </div>
    </div>
  )
}

export default About
